module.exports = __webpack_public_path__ + "static/media/icon_no_results.7e94d4dd.png";